import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { alSchema } from '_services/_schemas';

export const alService = {
    raw,
    load
};

async function raw(epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/alRaw?epno=' + epno, requestOptions, true, false);
};

async function load(epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/loadexlog?epno=' + epno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, alSchema);
            return flat;
        });
};
